import React from 'react';
import Spinner from '../../../../../../common/components/Spinner';
/**
 * @return {JSX.Element}
 * @constructor
 */

const centerLoaderStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
};

const UsageLoader = ({ style }) => {
  return (
    <div style={{ ...centerLoaderStyle, ...style }}>
      <Spinner size="3px" width="40px" height="40px" />
    </div>
  );
};

export default UsageLoader;
